import { Text, View } from "react-native";

import { Screen } from "@/components/ui/Screen";

/**
 * The loading state every public Show route shares: a page-shaped placeholder on the app's ground.
 *
 * A lone spinner on a slow show-floor connection reads as a failed page. `label` is the route's
 * status sentence, which a screen reader hears. Only the Show page passes `testID`, so a journey
 * waiting on a card or Hunt route's testID is not satisfied by the skeleton.
 */
export function PublicShowSkeleton({ label, testID }: { label: string; testID?: string; }) {
  return (
    <Screen testID={testID} className="events-page px-4 py-8" role="main">
      <View className="w-full max-w-[1180px] self-center gap-4" aria-hidden>
        <View className="h-8 w-2/3 rounded bg-surface-muted" />
        <View className="h-4 w-1/2 rounded bg-surface-muted" />
        <View className="mt-3 h-7 w-40 rounded bg-surface-muted" />
        <View className="h-[420px] w-full rounded-xl bg-surface-muted" />
      </View>
      <Text
        accessibilityLiveRegion="polite"
        className="mt-4 text-center font-body text-muted-foreground"
      >
        {label}
      </Text>
    </Screen>
  );
}
